// Grossary Scrolling filetr js Start Here
$(".ingredients-values ul li a ").on("click", function () {
  var pid = jQuery(this).closest(".ingredients-values ul").attr("id");
  var gro_id = "#" + pid;

  $("#cler_btn").show();
  $("#offsetaticle").val("0");
  $(".gross-id").removeClass("activetag");
  $(".filter-grossary-cat-item").removeClass("active-item");

  $(gro_id + "-item").addClass("activetag");
  $(gro_id + "-item")
    .parent()
    .addClass("active-item");
  $html = "html";
  get_article_data($html);
});

// Grossary Scrolling filetr js End Here

$(".testi-slick-carousel").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
});
jQuery(window).on("load", function () {
  jQuery("body").addClass("loaded");
  jQuery("body").removeClass("mmskin-loader");
});

jQuery(document).ready(function () {
  $(".shop-testimonial").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
  });
  /*===== Philosphy Slider Start Here =======*/
  $(".philosphy-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
  });
  /*===== Philosphy Slider End Here  =======*/


 /*===== Announce Slider Start Here =======*/
  $(".announce-slick-carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
  });
  /*===== Announce Slider End Here  =======*/

  /*===== everyday slider Start Here =======*/
  $(".shop-page-slider.before-after-video-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  /*=====everyday Slider End Here  =======*/
  /*===== Before After Video Slider Start Here =======*/
  $(".before-after-video-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    draggable: false,
    pauseOnHover: true,
    swipe: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  /*===== Before After Video Slider End Here  =======*/
  /*===== Product Page Slider Start Here =======*/
  $(".shop-page-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  /*===== Product Page Slider End Here  =======*/

  /*===== Facial Slider Start Here =======*/
  $(".facial-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
  });

  /*===== Facial Slider End Here  =======*/

  /*===== New Home Slider Start Here =======*/
  $(".home-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  /*===== New Home Slider End Here  =======*/

  
$(".product-slider").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  // Function to update Slick settings based on screen size
function updateSliderSettings() {
    if ($(window).width() < 800) {
        $(".product-slider").slick('slickSetOption', {
            slidesToShow: 1
        }, true);
    } else {
        $(".product-slider").slick('slickSetOption', {
            slidesToShow: 4
        }, true);
    }
}

// Call the function on window resize
$(window).resize(function() {
    updateSliderSettings();
});


// Initial call to set the slider settings based on the initial screen size
$(document).ready(function() {
    updateSliderSettings();
});
  /*===== FAQ JS Start  =======*/

  //   	jQuery('.accordion-title,.tab-title').click(function(){
  //    		jQuery(this).toggleClass('active').next().slideToggle();
  // 	});

  if (jQuery(window).width() < 767) {
    jQuery(".collection-filter-title").click(function () {
      jQuery(this).toggleClass("active").next().slideToggle();
    });
  }

  $(".accordion-part .accordion-title,.tab-title").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".accordion-content").slideUp(200);
    } else {
      $(".accordion-part .accordion-title").removeClass("active");
      $(this).addClass("active");
      $(".accordion-content").slideUp(200);
      $(this).siblings(".accordion-content").slideDown(200);
    }
  });
});

/*===== FAQ JS End  =======*/

(function ($) {
  "use strict";

  jQuery(window).on("load", function () {
    $(".uix-tabs").each(function (id) {
      var $this = $(this),
        $li = $this.find("ul > li"),
        liWidth = $li.first().outerWidth(),
        liHeight = $li.first().outerHeight(),
        liNum = $li.length,
        $contentbox = $this.find(".uix-tabs__content"),
        $contentboxcircle = $this.find(".uix-tabs__content_circle"),
        ulWidth = $this.data("width"),
        fullwidth = $this.data("fullwidth"),
        rotation = $this.data("rotation"),
        rotationRadius = $this.data("rotation-radius"),
        rotationWapperDeg = $this.data("rotation-wrapper-angle"),
        rotationDisplay = $this.data("rotation-display"),
        tabBoxID = id,
        isNumeric = /^[-+]?(\d+|\d+\.\d*|\d*\.\d+)$/;

      if (typeof fullwidth != typeof undefined && fullwidth == 1) {
        $li.css("width", 100 / liNum + "%");
      }

      if (typeof rotation === typeof undefined) {
        rotation = false;
      }

      if (typeof rotationWapperDeg === typeof undefined) {
        rotationWapperDeg = 0;
      }

      if (typeof rotationDisplay === typeof undefined) {
        rotationDisplay = 5;
      }

      $li.each(function (index) {
        index = index + 1;
        $(this).attr("href", "javascript:");
        $(this).attr("data-tab", tabBoxID + "-tabs-show" + index);
      });
      $($contentbox).each(function (index) {
        index = index + 1;
        $(this).attr("data-id", tabBoxID + "-tabs-show" + index);
      });
      $($contentboxcircle).each(function (index) {
        index = index + 1;
        $(this).attr("circle-data-id", tabBoxID + "-tabs-show" + index);
      });
      //           if ( rotation ) {

      //                     $this.find( '.uix-tabs__nav' ).css( {
      //                         'width'      : rotationRadius * 2 + 'px'
      //                     } );

      //                     $this.find( 'ul' ).css( {
      //                         'width'     : rotationRadius * 2 + 'px',
      //                         'height'    : rotationRadius * 2 + 'px',
      //                         'transform' : 'rotate('+parseFloat(rotationWapperDeg)+'deg)'
      //                     } );

      //                     //Layout components in a circle layout
      //                     var angle           = 0,
      //                         step            = 2 * Math.PI / rotationDisplay,
      //                         transitionDelay = 0,
      //                         pad             = $this.find( 'ul' ).width();

      //                     $this.find( 'ul > li' ).each( function() {
      //                          //Can'nt use arrow function here!!!
      //                         // 'this' works differently with arrow fucntions
      //                         var el          = $( this ),
      //                             x           = rotationRadius * Math.cos(angle) - liWidth / 1.1,
      //                             y           = rotationRadius * Math.sin(angle) - liHeight / 2.4;

      //                         el.css({
      //                             'transform'        : 'translate('+parseFloat( x )+'px,'+parseFloat( pad/2 + y )+'px)',
      //                             //'transition-delay' : transitionDelay + "s"
      //                         })
      //                         .find( '> a' )
      //                         .css({
      //                             'transform'        : 'rotate('+parseFloat(-rotationWapperDeg)+'deg)'
      //                         });

      //                         angle += step;
      //                         transitionDelay += 0.15;

      //                     });

      //                 	}

      var ww = $(window).width();

      if (ww <= 1280 && ww > 767) {
        console.log("< 1100");
        rotationResize(200);
      } else if (ww <= 767) {
        console.log("< 767");
        rotationResize(160);
      } else {
        console.log("else");
        rotationResize(300);
      }

      function rotationResize(rotationvalue) {
        if (rotation) {
          $this.find(".uix-tabs__nav").css({
            width: rotationvalue * 2.01 + "px",
          });

          $this.find("ul").css({
            width: rotationvalue * 2 + "px",
            height: rotationvalue * 2 + "px",
            transform: "rotate(" + parseFloat(rotationWapperDeg) + "deg)",
          });

          //Layout components in a circle layout
          var angle = 0,
            step = (2 * Math.PI) / rotationDisplay,
            transitionDelay = 0,
            pad = $this.find("ul").width();

          $this.find("ul > li").each(function () {
            //Can'nt use arrow function here!!!
            // 'this' works differently with arrow fucntions
            var el = $(this),
              x = rotationvalue * Math.cos(angle) - liWidth / 1.1,
              y = rotationvalue * Math.sin(angle) - liHeight / 2.4;

            el.css({
              transform:
                "translate(" +
                parseFloat(x) +
                "px," +
                parseFloat(pad / 2 + y) +
                "px)",
              //'transition-delay' : transitionDelay + "s"
            })
              .find("> a")
              .css({
                transform: "rotate(" + parseFloat(-rotationWapperDeg) + "deg)",
              });

            angle += step;
            transitionDelay += 0.15;
          });
        }
      }

      window.addEventListener(
        "resize",
        function (event) {
          var ww = $(window).width();

          if (ww <= 1280 && ww > 767) {
            console.log("< 1100");
            rotationResize(200);
          } else if (ww <= 767) {
            console.log("< 767");
            rotationResize(160);
          } else {
            console.log("else");
            rotationResize(300);
          }
        },
        true
      );

      // Tab Sliding Effext
      if ($this.find("ul li:first .uix-tabs__marker").length == 0) {
        $this
          .find("ul li:first")
          .prepend('<div class="uix-tabs__marker"></div>');
      }

      // Tab Fade Effect
      $this.on("click", "li", function (e) {
        var tabID = $(this).attr("data-tab"),
          index = parseFloat($(this).index() - 1);

        $(".accordion-item:first-child > a").addClass("active");
        $(".accordion-item:first-child > a")
          .siblings(".content")
          .slideDown(200);

        $this.find("li").removeClass("active");
        $this.find(".uix-tabs__content").removeClass("active");
        $this.find(".uix-tabs__content").hide();
        $this.find(".uix-tabs__content_circle").hide();
        $this.find(".uix-tabs__content_circle").removeClass("active");

        $(this).addClass("active");
        $(".tab-slider-section").addClass("active");
        $("[data-id=" + tabID + "]").addClass("active");
        $("[data-id=" + tabID + "]").fadeIn(800);
        $("[circle-data-id=" + tabID + "]").addClass("active");
        $("[circle-data-id=" + tabID + "]").fadeIn(800);

        $(".uix-tabs__nav > .circle-image").addClass("hide-main-circle");

        return false;
      });

      // Init
      $this.find("ul > li.active").trigger("click");

      //Active current tab
      var url = window.location.href,
        locArr,
        loc,
        curTab;

      if (url.indexOf("#") >= 0) {
        locArr = url.split("#");
        loc = locArr[1];
        curTab = $(".uix-tabs").find("ul > li:eq(" + loc + ")");
        curTab.trigger("click");
      }
    });
  });

  $(".accordion-item > a").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".accordion-item > a i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".accordion-item > a i").removeClass("fa-minus").addClass("fa-plus");
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      $(".accordion-item > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });

  // Tab Content class add after number circle click

  $(".uix-tabs__nav a").on("click", function () {
    $(".uix-tabs .uix-tabs-content").addClass("show-section");
  });
})(jQuery);

function openFaq(evt, aboutProduct) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active-item", "");
  }
  document.getElementById(aboutProduct).style.display = "block";
  evt.currentTarget.className += " active-item";
}

// Get the element with id="defaultOpen" and click on it
if ($("#defaultOpen").length) {
  document.getElementById("defaultOpen").click();
}

/*===== Before After JS Start  =======*/

// Call & init
$(document).ready(function () {
  $(".ba-slider").each(function () {
    var cur = $(this);
    // Adjust the slider
    var width = cur.width() + "px";
    cur.find(".resize img").css("width", width);
    // Bind dragging events
    drags(cur.find(".handle"), cur.find(".resize"), cur);
  });
});

// Update sliders on resize.
// Because we all do this: i.imgur.com/YkbaV.gif
$(window).resize(function () {
  $(".ba-slider").each(function () {
    var cur = $(this);
    var width = cur.width() + "px";
    cur.find(".resize img").css("width", width);
  });
});

function drags(dragElement, resizeElement, container) {
  // Initialize the dragging event on mousedown.
  dragElement
    .on("mousedown touchstart", function (e) {
      dragElement.addClass("draggable-image");
      resizeElement.addClass("resizable");

      // Check if it's a mouse or touch event and pass along the correct value
      var startX = e.pageX ? e.pageX : e.originalEvent.touches;

      // Get the initial position
      var dragWidth = dragElement.outerWidth(),
        posX = dragElement.offset().left + dragWidth - startX,
        containerOffset = container.offset().left,
        containerWidth = container.outerWidth();

      // Set limits
      minLeft = containerOffset + 1;
      maxLeft = containerOffset + containerWidth - dragWidth - 1;

      // Calculate the dragging distance on mousemove.
      dragElement
        .parents()
        .on("mousemove touchmove", function (e) {
          // Check if it's a mouse or touch event and pass along the correct value
          var moveX = e.pageX ? e.pageX : e.originalEvent.touches;

          leftValue = moveX + posX - dragWidth;

          // Prevent going off limits
          if (leftValue < minLeft) {
            leftValue = minLeft;
          } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
          }

          // Translate the handle's left value to masked divs width.
          widthValue =
            ((leftValue + dragWidth / 2 - containerOffset) * 100) /
              containerWidth +
            "%";

          // Set the new values for the slider and the handle.
          // Bind mouseup events to stop dragging.
          $(".draggable-image")
            .css("left", widthValue)
            .on("mouseup touchend touchcancel", function () {
              $(this).removeClass("draggable-image");
              resizeElement.removeClass("resizable");
            });
          $(".resizable").css("width", widthValue);
        })
        .on("mouseup touchend touchcancel", function () {
          dragElement.removeClass("draggable-image");
          resizeElement.removeClass("resizable");
        });
      e.preventDefault();
    })
    .on("mouseup touchend touchcancel", function (e) {
      dragElement.removeClass("draggable-image");
      resizeElement.removeClass("resizable");
    });
}

$(".product__info-container .spr-starrating span.visually-hidden").text(
  " Reviews"
);

jQuery(document).ready(function () {
  setTimeout(function () {
    if (jQuery(".product .rc-widget").length > 0) {
      jQuery(".product .price--show-badge").addClass("hide-price");
      jQuery(".product .price").hide();
    }
  }, 500);
});

//Smooth scrolling

$(document).ready(function () {
  $(".smooth-scroll").on("click", function (evt) {
    evt.preventDefault();
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top - 150,
    });
  });
  $(".philanthropy-page .smooth-scroll-other-sec").on("click", function (evt) {
    evt.preventDefault();
    $("html, body").animate({
      scrollTop: $($(this).attr("href")).offset().top - 105,
    });
  });

  $(".ingredients-page .ingredien-dec-high-light ul li a").on(
    "click",
    function (evt) {
      evt.preventDefault();
      $("html, body").animate({
        scrollTop: $($(this).attr("href")).offset().top - 150,
      });
    }
  );

  $("ul.list-menu--inline > li").mouseenter(function () {
    $(this).find("details").attr("open", "");
  });
  $("ul.list-menu--inline > li").mouseleave(function () {
    $(this).find("details").removeAttr("open", "");
  });

  //   var maxHeight = 0;

  //   $(".before-after-section .video-slider").each(function(){
  //     if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  //   });

  //   $(".before-after-section .container-new").height(maxHeight);
  //   	function setboxHeight() {
  // 			var SurroundingAreaHeight = $('.video-slider').height();

  //       $('.container-new').css('height' , SurroundingAreaHeight);
  // 		}
  // 		setboxHeight();
  // 		$(window).resize(function() {
  // 			setboxHeight();
  // 		});
});

/*----- Header -----*/
$(document).ready(function () {
  /*Megamenu related*/
  $(".has-mega-menu").hover(
    function () {
      $("#shopify-section-header").addClass("megamenu-active"); //Add the active class to the area is hovered
    },
    function () {
      $("#shopify-section-header").removeClass("megamenu-active");
    }
  );

  $(".slider-single").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
      {
        breakpoint: 749,
        settings: {
          arrows: true,
          centerMode: true,
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
  $(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-single",
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          centerMode: true,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 749,
        settings: {
          arrows: true,
          centerMode: true,
          slidesToShow: 1,
        },
      },
    ],
  });

  $("[data-slide]").click(function (e) {
    e.preventDefault();
    var slideno = $(this).data("slide");
    $(".slider-nav").slick("slickGoTo", slideno - 1);
  });

  // Handle tab clicks
       // Initialize players for all Vimeo iframes
        var players = {};
        $(".tab_content iframe").each(function () {
            var iframe = $(this)[0];
            var player = new Vimeo.Player(iframe);
            players[iframe.id] = player; // Store player in a dictionary for easy access
        });

$(".tabs li").click(function () {
    $(".tabs li").removeClass("active");
    $(".tab_content").removeClass("active");
    var tabId = $(this).attr("id");
    $("#" + tabId + "-content").addClass("active");
   
    $(this).addClass("active");
    var iframe = $("#" + tabId + "-content iframe");
    if (iframe.length) {
        iframe.css("opacity", 0);
        var src = iframe.attr("src");
        var newSrc = src.replace("autoplay=0", "autoplay=1");
        iframe.attr("src", newSrc);
        setTimeout(function () {
            iframe.css("opacity", 1);
        }, 1000);
    }
});



});


// Wait for the page to load
document.addEventListener("DOMContentLoaded", function() {
    // Find the specific li element with the data-tab attribute
    var liElement = document.querySelector('.tab-slider-section .first-index');
    var circleImage = document.querySelector('.circle-image');
    var liContentElement = document.querySelector('.uix-tabs__content_circle.first-index');
    var firstIndexContentElement = document.querySelector('.uix-tabs__content_circle.first-index-content');
    var uiTabsContentWrap = document.querySelector('.ui-tabs-content-wrap');
    uiTabsContentWrap.classList.add('show-section');
    // Check if the li element exists
    if (liElement) {
        liElement.click();
        liElement.classList.add('active');
        circleImage.classList.add('hide-main-circle');
        liContentElement.classList.add('active');
        firstIndexContentElement.classList.add('active');
        
    }
});

